import React, { useState, useRef } from 'react';
import { toast } from 'react-toastify';

const UploadFile = ({ inputId, acceptType, onFileLoaded }) => {
    const DEFAULT_MESSAGE = "";
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState(DEFAULT_MESSAGE);
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target?.files[0];

        if (!selectedFile) {
            return handleFileRemove();
        }

        if (acceptType) {
            const allowed = acceptType.split(',').map(type => type.trim().toLowerCase().replace(".", ""));
            let currentExtension = selectedFile.name.split(".").pop().toLowerCase();
            if (!allowed.includes(currentExtension)) {
                toast.warn("La extension del archivo deberia ser: " + acceptType);
                return handleFileRemove();
            }
        }

        setFile(selectedFile)
        setFileName(selectedFile.name);
        onFileLoaded(selectedFile);
    };

    const handleFileRemove = () => {
        setFile(null)
        setFileName(DEFAULT_MESSAGE);
        onFileLoaded("");
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    return (
        <div className="row align-items-center justify-content-center">

            <div className="col-auto position-relative">
                <label className="allow-pointer-cursor" htmlFor={inputId}>
                    <img
                        src="/img/upload-file.svg"
                        alt="upload_file"
                        title={fileName}
                        className="p-2"
                    />
                    <input
                        type="file"
                        id={inputId}
                        accept={acceptType}
                        className="d-none"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                    />
                </label>
                <i
                    title="Eliminar"
                    onClick={handleFileRemove}
                    hidden={!file}
                    className="
            mdi mdi-close-circle 
            color-rojo-megatone 
            position-absolute top-0 end-0 p-0 
            allow-pointer-cursor 
            hover-background-color 
            rounded
          "
                />
            </div>

            <div className="col-12 text-center"><p>{fileName}</p></div>
        </div>
    )
};

export default UploadFile;